import { render, staticRenderFns } from "./Promo2019_Toys.vue?vue&type=template&id=a56c361e&scoped=true&"
import script from "./Promo2019_Toys.vue?vue&type=script&lang=js&"
export * from "./Promo2019_Toys.vue?vue&type=script&lang=js&"
import style0 from "./Promo2019_Toys.vue?vue&type=style&index=0&id=a56c361e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c361e",
  null
  
)

export default component.exports